module.exports = __webpack_public_path__ + "img/companyIntro14.8f3cc503.png";